import React, { useCallback, useEffect, useState } from "react";
import { Edit, SimpleForm, useEditContext, useNotify } from "react-admin";

// Types
import { CreateOrganizationProps, User } from "../../types/organizations";

// Providers
import { usersProvider } from "../../providers/users";
import { OrganizationWithRelation } from "../../providers/organizations";

// Components
import { EditOrganizationForm } from "./EditOrganizationForm";
import EditToolbar from "../EditToolbar";

const Aside: React.FC = () => {
  const { record: data } = useEditContext<OrganizationWithRelation>();

  const [initialData, setInitialData] = useState<CreateOrganizationProps>({
    members: [],
    users: [],
    name: "",
    active: false,
    isTecheat: false,
  });

  const fetchData = useCallback(async () => {
    if (!data) {
      return;
    }

    const response = await usersProvider.getMany();

    if (response) {
      const users = await usersProvider.getUnassignedUsers();

      if (users) {
        const availableUsers: User[] = users;

        setInitialData((oldValue) => ({ ...oldValue, users: availableUsers }));
      }
    }
  }, [data]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <SimpleForm
      mode="onBlur"
      reValidateMode="onBlur"
      defaultValues={initialData}
      toolbar={<EditToolbar name="organization" resource="organizations" />}
    >
      <EditOrganizationForm formData={initialData} />
    </SimpleForm>
  );
};

export const EditComponent: React.FC = () => {
  const notify = useNotify();

  const onSuccess = () => {
    notify(`Organization updated successfully`, { type: "success" });
  };

  const onError = (error: any) => {
    notify(error.message, { type: "error" });
  };

  return (
    <Edit mutationMode="pessimistic" mutationOptions={{ onSuccess, onError }}>
      <Aside />
    </Edit>
  );
};
